/**
 * Maps PPM unit strings (e.g. "TemperatureUnit.DegreeCelsius") to their
 * short display symbols (e.g. "°C").
 *
 * Extend this map as new unit strings are encountered from the backend.
 */
export const UNIT_DISPLAY_MAP: Record<string, string> = {
  // Temperature
  'TemperatureUnit.DegreeCelsius': '°C',
  'TemperatureUnit.DegreeFahrenheit': '°F',
  'TemperatureUnit.Kelvin': 'K',

  // Power
  'PowerUnit.Watt': 'W',
  'PowerUnit.Kilowatt': 'kW',
  'PowerUnit.MegaWatt': 'MW',

  // Flow
  'FlowUnit.LiterPerSecond': 'l/s',
  'FlowUnit.LiterPerMinute': 'l/min',
  'FlowUnit.LiterPerHour': 'l/h',
  'FlowUnit.CubicMeterPerHour': 'm³/h',
  'FlowUnit.CubicMeterPerSecond': 'm³/s',

  // Pressure
  'PressureUnit.Bar': 'bar',
  'PressureUnit.MilliBar': 'mbar',
  'PressureUnit.Pascal': 'Pa',
  'PressureUnit.KiloPascal': 'kPa',

  // Energy
  'EnergyUnit.Joule': 'J',
  'EnergyUnit.KiloJoule': 'kJ',
  'EnergyUnit.MegaJoule': 'MJ',
  'EnergyUnit.KiloWattHour': 'kWh',

  // Mass
  'MassUnit.Kilogram': 'kg',
  'MassUnit.Gram': 'g',
  'MassUnit.Tonne': 't',

  // Length / Volume
  'LengthUnit.Millimeter': 'mm',
  'LengthUnit.Centimeter': 'cm',
  'LengthUnit.Meter': 'm',
  'VolumeUnit.Liter': 'l',
  'VolumeUnit.CubicMeter': 'm³',

  // Dimensionless / ratio
  'DimensionlessUnit.Percent': '%',
  'DimensionlessUnit.CoefficientOfPerformance': 'COP',
};

/**
 * Returns the display symbol for a PPM unit string.
 * Falls back to the raw string (or empty string when null/undefined).
 */
export function getUnitSymbol(unit: string | null | undefined): string {
  if (!unit) return '';
  return UNIT_DISPLAY_MAP[unit] ?? unit;
}

